export const projectUsages = [
  {
    label: 'Industrie',
    value: 'Industrie',
  },
  {
    label: 'Agriculture',
    value: 'Agriculture',
  },
  {
    label: 'Bureaux',
    value: 'Bureaux',
  },
  {
    label: 'Enseignement',
    value: 'Enseignement',
  },
  {
    label: 'Commerces',
    value: 'Commerces',
  },
  {
    label: 'Santé',
    value: 'Santé',
  },
  {
    label: 'Hôtellerie-Restauration',
    value: 'Hôtellerie',
  },
  {
    label: 'Transport',
    value: 'Transport',
  },
  {
    label: 'Copropriété ou Syndic',
    value: 'Copropriété ou Syndic',
  },
  {
    label: 'Résidentiel',
    value: 'Résidentiel',
  },
  {
    label: 'Autres',
    value: 'Autres',
  },
] as const;
